// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElevatorGroupControlMessage, ElevatorGroupControlMessageT } from './elevator-group-control-message';
import { EscalatorGroupControlMessage, EscalatorGroupControlMessageT } from './escalator-group-control-message';


export enum DeviceGroupControlContent {
  NONE = 0,
  ElevatorGroupControlMessage = 1,
  EscalatorGroupControlMessage = 2
}

export function unionToDeviceGroupControlContent(
  type: DeviceGroupControlContent,
  accessor: (obj:ElevatorGroupControlMessage|EscalatorGroupControlMessage) => ElevatorGroupControlMessage|EscalatorGroupControlMessage|null
): ElevatorGroupControlMessage|EscalatorGroupControlMessage|null {
  switch(DeviceGroupControlContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorGroupControlMessage': return accessor(new ElevatorGroupControlMessage())! as ElevatorGroupControlMessage;
    case 'EscalatorGroupControlMessage': return accessor(new EscalatorGroupControlMessage())! as EscalatorGroupControlMessage;
    default: return null;
  }
}

export function unionListToDeviceGroupControlContent(
  type: DeviceGroupControlContent, 
  accessor: (index: number, obj:ElevatorGroupControlMessage|EscalatorGroupControlMessage) => ElevatorGroupControlMessage|EscalatorGroupControlMessage|null, 
  index: number
): ElevatorGroupControlMessage|EscalatorGroupControlMessage|null {
  switch(DeviceGroupControlContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorGroupControlMessage': return accessor(index, new ElevatorGroupControlMessage())! as ElevatorGroupControlMessage;
    case 'EscalatorGroupControlMessage': return accessor(index, new EscalatorGroupControlMessage())! as EscalatorGroupControlMessage;
    default: return null;
  }
}
